import { FormControl, FormHelperText, FormLabel } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  DatePicker as MaterialDatePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { DatePickerProps } from ".";

const DatePicker = ({
  value,
  disabled,
  error,
  fullWidth,
  format = "DD/MM/YYYY",
  helperText,
  label,
  required,
  onChange,
  ...props
}: DatePickerProps) => {
  return (
    <FormControl disabled={disabled} fullWidth={fullWidth} required={required}>
      {label && <FormLabel>{label}</FormLabel>}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MaterialDatePicker
          value={value}
          disabled={disabled}
          format={format}
          slotProps={{ textField: { error } }}
          onChange={onChange}
          {...props}
        />
      </LocalizationProvider>
      {helperText && (
        <FormHelperText error={error}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default DatePicker;
